/**
 * Hero slider – slide navigation, autoplay, and video play/pause per slide.
 * Targets elements with [data-hero-slider] (one per section).
 */
(function() {
  function initHeroSlider(section) {
    if (!section || section.dataset.heroSliderInitialized === 'true') return;
    var track = section.querySelector('[data-hero-slider-track]');
    var slides = section.querySelectorAll('[data-hero-slide]');
    var dots = section.querySelectorAll('[data-hero-dot]');
    var prevBtn = section.querySelector('[data-hero-prev]');
    var nextBtn = section.querySelector('[data-hero-next]');
    var autoplay = section.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(section.dataset.autoplaySpeed || '5000', 10);
    var index = 0;
    var timer = null;
    var total = slides.length;
    if (total <= 1) {
      section.dataset.heroSliderInitialized = 'true';
      return;
    }
    function goTo(i) {
      index = ((i % total) + total) % total;
      slides.forEach(function(s, j) {
        s.classList.toggle('hero-slider__slide--active', j === index);
      });
      if (dots.length) {
        dots.forEach(function(d, j) {
          d.classList.toggle('hero-slider__dot--active', j === index);
        });
      }
      var activeSlide = slides[index];
      var videos = activeSlide.querySelectorAll('video');
      videos.forEach(function(v) { v.play().catch(function() {}); });
      section.querySelectorAll('[data-hero-slide] video').forEach(function(v) {
        if (!v.closest('.hero-slider__slide--active')) v.pause();
      });
      if (autoplay) resetTimer();
    }
    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }
    function resetTimer() {
      if (timer) clearInterval(timer);
      timer = setInterval(next, autoplaySpeed);
    }
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var i = parseInt(this.dataset.index, 10);
        if (!isNaN(i)) goTo(i);
      });
    });
    section.addEventListener('mouseenter', function() {
      if (timer) clearInterval(timer);
      timer = null;
    });
    section.addEventListener('mouseleave', function() {
      if (autoplay) resetTimer();
    });
    if (autoplay) resetTimer();
    section.dataset.heroSliderInitialized = 'true';
  }
  function initAll() {
    document.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function(ev) {
    var section = ev.target.querySelector('[data-hero-slider]');
    if (section) initHeroSlider(section);
  });
})();
